import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { selectUser } from 'reducers/user';
import { reportError } from 'helpers/error-reporting';
import { ExternalLink } from 'next/components/ui';

const OpenBeacon = styled(ExternalLink)`
  ${({ light }) =>
    light &&
    `
    color: var(--white);
    font-weight: var(--bold);
    text-decoration: underline;

    &:hover {
      color: var(--text-tertiary);
    }
  `}
`;

const BeaconLink = ({
  children,
  email,
  light = false,
  mailto = 'sales@appcues.com',
  message,
  name,
  subject,
  ...unhandledProps
}) => {
  const text = ['Hi,', message, 'Thanks!'].join('\n\n');

  // Handle potential upsell request. If the Helpscout beacon exists on the
  // page, use that to contact the sales team. However if the beacon fails or
  // does not exist on the page, fallback to using a mailto link
  const handleClick = event => {
    if (window.Beacon) {
      try {
        /* eslint-disable new-cap */
        window.Beacon('prefill', {
          name,
          email,
          subject,
          text,
        });
        window.Beacon('navigate', '/ask/');
        window.Beacon('open');
        /* eslint-enable new-cap */

        event.preventDefault();
      } catch (error) {
        reportError(error);
      }
    }
  };

  return (
    <OpenBeacon
      href={`mailto:${mailto}?subject=${encodeURIComponent(
        subject
      )}&body=${encodeURIComponent(message)}`}
      onClick={handleClick}
      light={light}
      {...unhandledProps}
    >
      {children}
    </OpenBeacon>
  );
};

BeaconLink.propTypes = {
  children: PropTypes.node,
  // The user email
  email: PropTypes.string,
  // Whether or not light colors should be used.
  // Used when link is on a tooltip.
  light: PropTypes.bool,
  // Fallback email in case helpscout beacon does not load.
  mailto: PropTypes.string,
  // The beacon message
  message: PropTypes.string,
  // The user name
  name: PropTypes.string,
  // The beacon subject
  subject: PropTypes.string,
};

const mapStateToProps = state => {
  const { fullname, email } = selectUser(state);

  return {
    email: email || '',
    name: fullname || '',
  };
};

export default styled(connect(mapStateToProps)(BeaconLink))``;
